import React from 'react';
import { useTheme } from '@material-ui/core/styles';

import CircularProgress from '@material-ui/core/CircularProgress';

export default function Loader() {
    const theme = useTheme();

  return (
    <div style={{display: 'flex', justifyContent: 'center', paddding: theme.spacing(1)}}>
    <CircularProgress color="primary" size='5rem'/>
    </div>
  )
}